import { NewsStatus } from "../models/news-status.enum";

export namespace NewsActions {
    export class GetAllNews {
        public static readonly type = "[NewsActions] GetAllNews";
    }

    export class GetUnreadNews {
        public static readonly type = "[NewsActions] GetUnreadNews";
    }

    export class GetUnseenNewsCount {
        public static readonly type = "[NewsActions] GetUnseenNewsCount";
    }

    export class GetCurrentNews {
        public static readonly type = "[NewsActions] GetCurrentNews";
        constructor(public newsId: number) {}
    }

    export class SetNewsStatus {
        public static readonly type = "[NewsActions] SetNewsStatus";
        constructor(public newsId: number, public status: NewsStatus) {}
    }

    export class SetStatusForAll {
        public static readonly type = "[NewsActions] SetStatusForAll";
        constructor(public status: NewsStatus) {}
    }

    export class SetStatusForAllUnread {
        public static readonly type = "[NewsActions] SetStatusForAllUnread";
        constructor(public status: NewsStatus) {}
    }

    export class RemoveNews {
        public static readonly type = "[NewsActions] RemoveNews";
        constructor(public newsId: number) {}
    }
}
